import { render } from "./Detail.vue?vue&type=template&id=3189c295&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=3189c295&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3189c295"]])

export default __exports__